if (!customElements.get("th-accordion")) {
  class ThAccordion extends HTMLElement {
    constructor() {
      super();

      this.accordionSelector = "[data-th-accordion]";
      this.triggerSelector = "[data-th-accordion-toggle]";
      this.contentSelector = "[data-th-accordion-content]";
      this.activeClass = "th-active";
    }
    connectedCallback() {
      setTimeout(() => {
        this.attachListeners();
      });
    }
    attachListeners() {
      this.querySelectorAll(this.triggerSelector).forEach(
        (trigger) => {
          trigger.addEventListener("click", (event) => {
            this.handleAccordionToggle(event)
          });
          window.addEventListener("load", (event) => {
            this.handleAccordionToggle(event)
          });
          window.addEventListener("DOMContentLoaded", (event) => {
            this.handleAccordionToggle(event)
          });
        }
      );
    }
    handleAccordionToggle(e) {
      const accordionContainer = this.querySelector(this.accordionSelector);
      const accordionContent = this.querySelector(this.contentSelector);
      if (!accordionContainer || !accordionContent) {return}

      if (e.type == "click") {
        accordionContainer.classList.toggle(this.activeClass);
      }
      
      if (accordionContainer.classList.contains(this.activeClass)) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      } else {
        accordionContent.style.maxHeight = 0;
      }
    }
  }
  customElements.define("th-accordion", ThAccordion);
}

if (!customElements.get("th-swatch-kit-form")) {
  class ThSwatchKitForm extends HTMLElement {
    constructor() {
      super();

      this.formData = {"Swatches": [], "Quantity": [], "Price": []};
      this.currentStep = 1;
      this.lastStep = 0;
      this.selectedSwatchesCount = 0;
      this.selectedSwatchesMax = this.dataset.maxSwatches;

      this.ACTIVE_CLASS = "th-active";
      this.LOADING_CLASS = "th-loading";

      this.FORM_FIELDS_SELECTOR = "[data-th-input]";
      this.FORM_SWATCH_FIELDS_SELECTOR = "[data-th-swatch-checkbox]";
    }
    connectedCallback() {
      this.STEP_INDICATOR_LINKS = this.querySelectorAll(`[data-th-step-indicator]`);

      this.FORM_ELEMENT = this.querySelector("[data-th-skf]");
      this.FORM_FIELDS = this.querySelectorAll(this.FORM_FIELDS_SELECTOR);
      this.FORM_SWATCH_FIELDS = this.querySelectorAll(this.FORM_SWATCH_FIELDS_SELECTOR);
      this.FORM_SUBMIT_BUTTONS = this.querySelectorAll("[data-th-go-to-step]");
      this.FORM_EDIT_BUTTONS = this.querySelectorAll("[data-th-edit-step]");

      this.SELECTED_SWATCHES = this.querySelector("[data-th-selected-swatches-desktop]");
      this.SELECTED_SWATCHES_ACCORDION = this.querySelector("[data-th-selected-swatches]");
      this.SELECTED_SWATCHES_ACCORDION_WRAPPER = this.querySelector("[data-selected-swatch-accordion]");
      this.SELECTED_SWATCHES_SUMMARY = this.querySelector("[data-th-selected-swatches-summary]");
      this.SELECTED_SWATCHES_COUNT_ELMS = this.querySelectorAll("[data-swatch-count]");

      this.DESKTOP_SIDEBAR = this.querySelector("[data-th-desktop-sidebar]");

      this.CONTACT_INFO_SUMMARY_ELMS = this.querySelectorAll("[data-form-fields-summary]");
      this.COMPLETE_MESSAGE = this.querySelector("[data-th-client-email]");

      if (!this.FORM_ELEMENT || !this.SELECTED_SWATCHES_ACCORDION || !this.SELECTED_SWATCHES_ACCORDION_WRAPPER || !this.SELECTED_SWATCHES || !this.DESKTOP_SIDEBAR || !this.COMPLETE_MESSAGE) {return}

      this.attachListeners();
      this.attachRecurringListeners();
    }

    attachListeners() {
      this.FORM_FIELDS.forEach((field) => {
        field.addEventListener("focus", (event) => {
          let target = event.target;
          if (!target) {return}
          let targetParent = target.parentElement;
          targetParent.classList.add(this.ACTIVE_CLASS);
        });
        field.addEventListener("blur", (event) => {
          let target = event.target;
          if (!target) {return}
          let targetParent = target.parentElement;
          if (target.value.trim() === '') {
            targetParent.classList.remove(this.ACTIVE_CLASS);
          }
        });
      });
      this.FORM_SUBMIT_BUTTONS.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.handleNextStep(button);
        });
      });
      this.FORM_SWATCH_FIELDS.forEach((swatch) => {
        swatch.addEventListener("change", () => {
          this.toggleSwatchToSelected(swatch);
        });
      });
      this.FORM_EDIT_BUTTONS.forEach((button) => {
        button.addEventListener("click", () => {
          let stepNumber = Number(button.dataset.thEditStep);
          if (stepNumber < this.currentStep) {
            this.handlePreviousStep(button);
          }
        });
      });
    }

    attachRecurringListeners() {
      this.querySelectorAll("[data-th-remove-selected-swatch]").forEach((button) => {
        button.addEventListener("click", () => {
          this.toggleSwatchToSelected(button);
        });
      });
    }

    async handleNextStep(button) {
      let nextStep = Number(button.dataset.thGoToStep);
      if (this.currentStep === 1) {
        this.formData = {"Swatches": [], "Quantity": [], "Price": [], "SKU": []};
      }
      const isValidated = await this.validateCurrentFields();

      if (isValidated) {
        this.lastStep = this.currentStep;
        if (this.currentStep < 4) {
          this.currentStep++;
          if (this.currentStep < 4) {
            this.handleStepUiChanges();
          }
        }
        if (this.currentStep === 3) {
          this.handleContactInfoSummary();
        } 
        if (this.currentStep === 4 && nextStep === 4) {
          this.submitFormData();
        }
      }
    }

    handlePreviousStep(button) {
      this.lastStep = this.currentStep;
      this.currentStep = Number(button.dataset.thEditStep);
      this.handleStepUiChanges();
    }

    validateCurrentFields() {
      return new Promise((validate) => {
        const currentStepWrapper = this.querySelector(`[data-th-step='${this.currentStep}']`);
        let validFlg = 0;
        if (!currentStepWrapper) {
          validate(false);
          return;
        }
        const currentFormFields = currentStepWrapper.querySelectorAll(this.FORM_FIELDS_SELECTOR);
        if (currentFormFields.length > 0) {
          currentFormFields.forEach((field) => {
            if (field.hasAttribute("data-required")) {
              if (this.validateIndividualField(field)) {
                validFlg += 1;
                this.formData[field.name] = field.value;
              }
            } else if (field.hasAttribute("data-th-swatch-checkbox")) {
              if (field.checked) {
                validFlg += currentFormFields.length;
                if (this.formData['Swatches']) {
                  this.formData['Swatches'].push(`${field.name} - ${field.value}`);
                }
                if (this.formData['Quantity']) {
                  this.formData['Quantity'].push(1);
                }
                if (this.formData['Price']) {
                  this.formData['Price'].push(0);
                }
                if (this.formData['SKU']) {
                  let currentSku = field.dataset.sku;
                  if (currentSku) {
                    this.formData['SKU'].push(currentSku);
                  }
                }
              }
            } else {
              validFlg += 1;
              this.formData[field.name] = field.value;
            }
            if (validFlg == currentFormFields.length) {
              validate(true);
            }
          });
        } else {
          validate(true);
        }
      });
    }

    validateIndividualField(field) {
      if (field.type === 'text') {
        if (field.value === '') {
          this.toggleError(field, true);
          return false;
        }
        this.toggleError(field, false);
        return true;
      } else if (field.type === 'email') {
        if (field.value.trim() === '') {
          this.toggleError(field, true);
          return false;
        }
        const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
        if (!emailPattern.test(field.value)) {
          this.toggleError(field, true);
          return false;
        }
        this.toggleError(field, false);
        return true;
      } else if (field.type === 'select-one') {
        if (field.value.trim() === '') {
          this.toggleError(field, true);
          return false;
        }
        this.toggleError(field, false);
        return true;
      } else if (field.type === 'tel') {
        if (field.value === '') {
          this.toggleError(field, true);
          return false;
        }
        this.toggleError(field, false);
        return true;
      }
    }

    toggleError(field, bool) {
      if (bool) {
        if (!field) {return}
        field.classList.add('show-error');
      } else {
        if (!field) {return}
        field.classList.remove('show-error');
      }
    }

    handleStepUiChanges() {
      const currentStepWrapper = this.querySelector(`[data-th-step='${this.currentStep}']`);
      const lastStepWrapper = this.querySelector(`[data-th-step='${this.lastStep}']`);
      const currentSubmitButton = this.querySelectorAll(`[data-th-go-to-step='${this.currentStep + 1}']`);
      const lastSubmitButton = this.querySelectorAll(`[data-th-go-to-step='${this.lastStep + 1}']`);

      if (currentStepWrapper || lastStepWrapper || lastSubmitButton || currentStepIndicator) {
        currentStepWrapper.classList.add(this.ACTIVE_CLASS);
        lastStepWrapper.classList.remove(this.ACTIVE_CLASS);
      }
      lastSubmitButton.forEach((button) => {
        button.classList.remove(this.ACTIVE_CLASS);
      });
      this.STEP_INDICATOR_LINKS.forEach((step) => {
        let stepNumber = Number(step.dataset.thStepIndicator);
        if (stepNumber <= this.currentStep) {
          step.classList.add(this.ACTIVE_CLASS);
        } else {
          step.classList.remove(this.ACTIVE_CLASS);
        }
      });

      currentSubmitButton.forEach((button) => {
        button.classList.add(this.ACTIVE_CLASS);
      });

      if (this.currentStep > 2) {
        this.SELECTED_SWATCHES_ACCORDION_WRAPPER.classList.remove(this.ACTIVE_CLASS);
      } else {
        this.SELECTED_SWATCHES_ACCORDION_WRAPPER.classList.add(this.ACTIVE_CLASS);
      }

      if (this.currentStep > 1) {
        this.DESKTOP_SIDEBAR.classList.remove(this.ACTIVE_CLASS);
      } else {
        this.DESKTOP_SIDEBAR.classList.add(this.ACTIVE_CLASS);
      }

      this.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    toggleSwatchToSelected(swatch) {
      let swatchId = null;
      if (swatch.id) {
        swatchId = swatch.id;
        // Prevent adding more swatches if max is reached
        if (this.selectedSwatchesCount >= this.selectedSwatchesMax && swatch.checked) {
          swatch.checked = false;
          return;
        }
      } else if (swatch.dataset.thRemoveSelectedSwatch) {
        swatchId = swatch.dataset.thRemoveSelectedSwatch;
        let swatchCheckbox = this.querySelector(`#${swatchId}`);
        if (swatchCheckbox) {
          swatchCheckbox.checked = false;
        }
      }
      if (swatch.checked && swatchId) {
        const swatchLabel = this.querySelector(`[for='${swatchId}']`);
        if (!swatchLabel) {return}
        const swatchImageElem = swatchLabel.querySelector(".th-skf__collection-swatch-image");
        const swatchTextElem = swatchLabel.querySelector(".th-skf__collection-swatch-title");
        if (!swatchImageElem) {return}
        const swatchBackgroundColor = swatchImageElem.style.backgroundColor;
        const swatchBackgroundImage = swatchImageElem.dataset.thSwatchImage;
        const swatchText = swatchTextElem.innerText;
        const swatchAccordionHtml = `
          <div data-selected-swatches-swatch="${swatchId}" class="th-skf__collection-swatch">
            <div class="th-skf__collection-swatch-image-wrap">
              <div class="th-skf__collection-swatch-image" style="background-color: ${swatchBackgroundColor}; background-image: url(${swatchBackgroundImage});"></div>
              <div data-th-remove-selected-swatch="${swatchId}" class="th-skf__swatch-icon">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.29288 3.96151L0.192482 7.0619L0.899588 7.76901L3.99998 4.66861L7.10039 7.76902L7.8075 7.06191L4.70709 3.96151L7.97066 0.697944L7.26355 -0.0091629L3.99998 3.2544L0.736428 -0.00915575L0.0293212 0.697951L3.29288 3.96151Z" fill="white"/>
                </svg>            
              </div>
            </div>
            <div class="th-skf__collection-swatch-title">${swatchText}</div>
          </div>
        `;
        const swatchSummaryHtml = `
          <div data-selected-swatches-swatch="${swatchId}" class="th-skf__collection-swatch">
            <div class="th-skf__collection-swatch-image-wrap">
              <div class="th-skf__collection-swatch-image" style="background-color: ${swatchBackgroundColor}; background-image: url(${swatchBackgroundImage});"></div>
            </div>
            <div class="th-skf__collection-swatch-title">${swatchText}</div>
          </div>
        `;
        this.SELECTED_SWATCHES.innerHTML += swatchAccordionHtml;
        this.SELECTED_SWATCHES_ACCORDION.innerHTML += swatchAccordionHtml;
        this.SELECTED_SWATCHES_SUMMARY.innerHTML += swatchSummaryHtml;

        this.selectedSwatchesCount++;
        this.handleSwatchCountElements();

        this.attachRecurringListeners();
      } else if (swatchId) {
        const selectedSwatches = this.querySelectorAll(`[data-selected-swatches-swatch="${swatchId}"]`);
        selectedSwatches.forEach((swatch) => {
          swatch.remove();
        });

        this.selectedSwatchesCount--;
      }
      this.handleOrderSwatchesButtonState();
      this.handleSwatchCountElements();
      this.handleMaxSwatchesInputState();
    }

    handleSwatchCountElements() {
      this.SELECTED_SWATCHES_COUNT_ELMS.forEach((elm) => {
        elm.innerText = this.selectedSwatchesCount;
      });
    }

    handleMaxSwatchesInputState() {
      // Check if max swatches reached and update UI accordingly
      if (this.selectedSwatchesCount >= this.selectedSwatchesMax) {
        this.FORM_SWATCH_FIELDS.forEach(field => {
          if (!field.checked) {
            field.disabled = true;
          }
        });
      } else {
        this.FORM_SWATCH_FIELDS.forEach(field => {
          field.disabled = false;
        });
      }
    }

    handleContactInfoSummary() {
      const summaryHtml = `
        <span>${this.formData["First Name"]} ${this.formData["Last Name"]}</span>
        <span>${this.formData["Phone"]}</span>
        <span>${this.formData["Address Line 1"]}</span>
        ${this.formData["Address Line 2"] ? 
            `<span>${this.formData["Address Line 2"]}</span>`
        : ''}
        <span>${this.formData["Email"]}</span>
        <span>${this.formData["City"]}, ${this.formData["State"]} ${this.formData["Zipcode"]}</span>
      `
      this.CONTACT_INFO_SUMMARY_ELMS.forEach((elm) => {
        elm.innerHTML = summaryHtml;
      });

      //Handles email in complete message after form submit
      this.COMPLETE_MESSAGE.innerHTML = this.formData["Email"];
    }
  
    submitFormData() {
      this.classList.add(this.LOADING_CLASS);

      const orderID = `swatch-kit-order-${parseInt(Date.now() * Math.random()).toString()}-${Date.now().toString()}`;
      const orderIDObj = {"orderNumber": orderID};
      this.formData = { ...orderIDObj, ...this.formData };

      const params = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','tw_source','tw_adid'];
      const searchParams = new URLSearchParams(window.location.search);
      params.forEach((param) => {
        const paramVal = searchParams.get(param);
        if (paramVal) {
          this.formData[param] = paramVal;
        };
      })

      const formAsString = new URLSearchParams(this.formData).toString();

      fetch(`https://hooks.zapier.com/hooks/catch/8792631/bd7q93g/?${formAsString}`, {
        method: "GET",
      }).then(function (response) {
        if (response.ok) {
          this.classList.remove(this.LOADING_CLASS);
          this.handleStepUiChanges();
        } else {
          this.classList.remove(this.LOADING_CLASS);
          const submitError = this.querySelector("[data-th-submit-error]");
          if (submitError) {
            submitError.classList.add(this.ACTIVE_CLASS);
          }
        }
      }.bind(this)).catch(function (error) {
        this.classList.remove(this.LOADING_CLASS);
        const submitError = this.querySelector("[data-th-submit-error]");
        if (submitError) {
          submitError.classList.add(this.ACTIVE_CLASS);
        }
      }.bind(this));

      this.handleStepUiChanges();
    }

    handleOrderSwatchesButtonState() {
      const orderSwatchesButton = this.querySelectorAll('[data-th-go-to-step="2"]');
      if (this.selectedSwatchesCount === 0) {
        orderSwatchesButton.forEach((button) => {
          button.innerHTML = "Select your swatches";
          button.disabled = true;
        });
      } else if (this.selectedSwatchesCount === 1) {
        orderSwatchesButton.forEach((button) => {
          button.innerHTML = `
          <svg width="33" height="31" viewBox="0 0 33 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32.8594 26.3098L31.1793 24.5662L32.8594 22.8225L31.1793 21.0789L32.8594 19.3421L31.1793 17.5984L32.8594 15.8548L31.1793 14.1112L32.8594 12.3743L31.4538 11.0565L33 9.49531L31.36 7.73817L29.8138 9.29933L28.5688 8.04905L26.8418 9.74537L25.1148 8.04905L24.2112 8.93438L22.5578 7.21779L24.258 5.45389L22.859 4.13604L24.3785 2.60192L21.9353 -0.0135155L20.3757 1.56115L19.1373 0.31088L17.4037 2.0072L15.6767 0.31088L13.9497 2.0072L12.2294 0.31088L10.5024 2.0072L8.77546 0.337912L7.04848 2.03423L5.3215 0.331154L4.10325 1.56791L2.56369 0.0135174L0.153955 2.44648L1.69351 4.00087L0.220893 5.48768L1.90101 7.23807L0.227586 8.98169L1.90771 10.7253L0.227586 12.4622L1.90771 14.2058L0.227586 15.9494L1.90771 17.693L0.220893 19.4367L1.45254 20.6802L0 22.1467L2.40974 24.5797L3.86227 23.1131L5.32819 24.5932L7.06187 22.8969L8.78884 24.5932L10.5158 22.8969L10.6765 23.0591L12.1625 24.6L10.4824 26.3368L11.7207 27.5871L10.2682 29.0536L11.8479 30.6486L13.3004 29.182L14.773 30.6688L16.5 28.9725L18.227 30.6688L19.954 28.9725L21.6742 30.6688L23.4012 28.9725L25.1282 30.6688L26.8552 28.9725L28.5755 30.6688L29.7335 29.4726L31.2663 31.0203L32.9398 29.3577L31.4002 27.8034L32.8594 26.3301V26.3098ZM7.06187 21.2276L5.34158 22.9172L3.86227 21.4303L2.40974 22.8969L1.66004 22.14L3.11258 20.6734L1.86755 19.4232L3.54097 17.6863L1.86085 15.9427L3.54097 14.199L1.86085 12.4554L3.54097 10.7186L1.86085 8.97493L3.54097 7.23131L1.86755 5.49444L3.35355 3.99411L1.814 2.43972L2.56369 1.6828L4.10325 3.23719L5.33489 1.99368L7.05517 3.68324L8.78215 1.98692L10.5091 3.68324L12.2361 1.98692L13.9564 3.68324L15.6834 1.98692L17.4103 3.68324L19.1306 1.99368L20.3824 3.25071L21.9219 1.69632L22.7586 2.5884L21.1856 4.17659L22.598 5.5012L20.9379 7.21779L22.6181 8.96141L20.9379 10.705L22.6181 12.4487L20.9379 14.1855L22.6181 15.9291L20.9379 17.6728L22.6114 19.4096L21.1454 20.8897L22.6783 22.4373L21.8416 23.2686L20.2953 21.7074L19.1306 22.9104L17.417 21.2276L15.6901 22.9239L13.9631 21.2276L12.2361 22.9239L10.5158 21.2276L8.78884 22.9239L7.06187 21.2276Z" fill="white"></path>
          </svg>
          Order free fabric swatches
          `;
          button.disabled = false;
        });
      }
    }
  }
  customElements.define("th-swatch-kit-form", ThSwatchKitForm);
}
